import React from "react"
import slugify from "slugify"
import { Button } from "@bw/bits"
import * as resolvers from "@bw/modules/resolvers"

const Header = ({ modules, page, breadcrumbsLinks }) => {
  if (!modules) {
    return null
  }

  return modules
    .filter(module => module !== null)
    .map((module, i) => {
      const LoadedModule = resolvers[module.__typename.replace("Module", "")]

      if (typeof LoadedModule === "undefined") {
        return null
      }

      if (module.__typename === "PageHeaderModule") {
        module.pictogram = page.pictogram?.value || "cross"
      }

      return <LoadedModule key={i} {...module} />
    })
}

const Footer = ({ modules }) => {
  return modules
    .filter(module => module !== null)
    .map((module, i) => {
      const LoadedModule = resolvers[module.__typename.replace("Module", "")]

      if (typeof LoadedModule === "undefined") {
        return null
      }

      return <LoadedModule key={i} {...module} />
    })
}

const Content = ({ modules }) => {
  if (!modules) {
    return null
  }

  return modules
    .filter(module => module !== null)
    .map((module, i) => {
      const LoadedModule = resolvers[module.__typename.replace("Module", "")]
      if (typeof LoadedModule === "undefined") {
        return null
      }

      if (module.buttonType?.value === "url" && module.buttonUrl) {
        module.button = (
          <Button
            label={module.buttonText}
            href={module.buttonUrl}
            external={module.buttonIsExternal}
          />
        )
      }

      if (module.buttonType?.value === "entry" && module.buttonEntry) {
        if (module.buttonIsExternal) {
          module.button = (
            <Button
              label={module.buttonText}
              href={module.buttonEntry.url}
              external={true}
            />
          )
        } else {
          module.button = (
            <Button label={module.buttonText} to={module.buttonEntry.url} />
          )
        }
      }

      /**
       * when we find a Magazine module that is followed by a teasers module,
       * we must ensure that the magazine is not displayed twice
       */
      if (
        module.__typename === "MagazinesModule" &&
        modules[i + 1]?.__typename === "TeasersLatestModule"
      ) {
        modules[i + 1].exclude = [module.magazine.id]
      }

      module.anchor =
        module.ancre ??
        slugify([module.suptitle, module.title, module.subtitle].join("-"), {
          lower: true,
        })

      return <LoadedModule key={i} {...module} />
    })
}

export { Header, Footer, Content }
